import { Component, OnInit, ViewChild, ElementRef, Optional } from "@angular/core";
import { AuthService } from "../../providers/auth.service";
import { trigger, state, style, transition, animate } from "@angular/animations";
import { BvDialogService, BvDialogRef } from "../../design-system";
import { RoutingService } from "../../providers/routing.service";

import { BvDialogTitleComponent, BvDialogBodyComponent, BvDialogFooterComponent } from "../../design-system/primitives/dialog.component";
import { BvButtonComponent } from "../../design-system/primitives/button.component";
import { BvFormFieldComponent } from "../../design-system/primitives/form-field.component";
import { BvInputDirective } from "../../design-system/primitives/input.directive";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";

@Component({
    selector: "app-login",
    templateUrl: "./login.component.html",
    styleUrls: ["./login.component.scss"],
    animations: [
        trigger('tdCollapse', [
            // overflow:hidden is on BOTH states so it stays static (clipping the
            // content while height animates) instead of being diffed into the
            // transition — animating overflow isn't allowed and logs a warning.
            state('true', style({ height: '0', overflow: 'hidden' })),
            state('false', style({ height: '*', overflow: 'hidden' })),
            transition('true <=> false', animate('{{duration}}ms ease-in-out'), { params: { duration: 200 } })
        ])
    ],
    imports: [BvDialogTitleComponent, BvDialogBodyComponent, BvButtonComponent, BvFormFieldComponent, BvInputDirective, FormsModule, BvDialogFooterComponent, TranslateModule]
})
export class LoginComponent implements OnInit {
  collapseTrigger: boolean = true;
  topTrigger: boolean = false;
  loginEmail!: string;
  loginPassword!: string;
  constructor(
    public auth: AuthService,
    private dialog: BvDialogService,
    private routing: RoutingService,
    @Optional() private dialogRef: BvDialogRef<LoginComponent>
  ) {}

  ngOnInit() {
    // If successful login and we're on standalone page, redirect to lobby
    if (!this.dialogRef) {
      this.auth.user.subscribe(user => {
        if (user) {
          this.routing.toLobby();
        }
      });
    }
  }
  
  socialLogin(provider: string) {
    this.auth.socialLogin(provider);
    if (this.dialogRef) {
      this.dialog.closeAll();
    }
  }
  
  loginEmailPassword() {
    this.auth.loginEmail(this.loginEmail, this.loginPassword);
    if (this.dialogRef) {
      // Dialog will be closed by auth service on successful login
    }
  }
  resetPassword() {
    this.auth.resetPassword(this.loginEmail);
  }
  toggleCollapse() {
    this.collapseTrigger = !this.collapseTrigger;
    this.topTrigger = !this.topTrigger;
  }
}
